import { world } from '../../../../languages';
import { getUserOS, getUserSID } from '../../../../services/quality-events/quality-events.helpers';

export enum PURCHASE_FORM_MODE {
    FREE = 'FREE',
    PAID = 'PAID'
};

export type FormDataType = {
    acceptAgb: string | boolean;
    city: string;
    country: string;
    email: string;
    firstName: string;
    gender: 'female' | 'male';
    lastName: string;
    postcode: string;
    streetAddress: string;
    streetAddress2: string;
    type: string;
    company?: string;
    vat_id?: string;
    sid?: string;
    os?: string;
};

export type FormErrorsType = {
    [key: string]: boolean
};

export const FormInitialData: FormDataType = {
    acceptAgb: '',
    city: '',
    country: world.toUpperCase(),
    email: '',
    firstName: '',
    gender: 'female',
    lastName: '',
    postcode: '',
    streetAddress: '',
    streetAddress2: '',
    type: 'person',
    vat_id: '',
    sid: getUserSID(),
    ...(getUserOS() && { os: getUserOS() })
};
